import {Component, Injector} from '@angular/core';
import {format} from 'date-fns';
import {ApiResponse} from '../../../../../Services/Api/base-api.service';
import {WidgetDataControllerComponent} from '../../../../Controller/widget-data-controller-component';
import {ClockInDto, RankDto} from '../../../../../Models/Rrhh/Clock-In/clock-in-list.interface';
import {ClockInApiService} from '../../../../../Services/Api/Rrhh/Clock-in/clock-in-api.service';
import {ClockInFilters} from '../../../../../Models/Rrhh/Clock-In/clock-in-filters.model';

@Component({
  selector: 'app-last-clock-in-widget',
  templateUrl: './last-clock-in-widget.component.html',
  styleUrls: ['./last-clock-in-widget.component.scss'],
  standalone: false
})
export class LastClockInWidgetComponent extends WidgetDataControllerComponent<RankDto[]> {

  get widgetData(): RankDto[] {
    return this.data ? this.data : this.fakeData;
  }

  constructor(
    protected override injector: Injector,
    protected clockInService: ClockInApiService
  ) {
    super(injector, clockInService);

    this.getFakeData();
  }


  /**
   * Obtener datos falsos
   *
   */
  getFakeData() {
    this.fakeData = [
      {
        id: 1,
        id_local: 22,
        local: 'Yurest',
        id_usuario: 1,
        usuario: 'Pablo García',
        avatar: '',
        observaciones: '',
        activo: 0,
        id_estado_firma: 0,
        estado_firma: 'No solicitada',
        firma: '',
        inicio: 1744006974000,
        hora_inicio: '08:22',
        fin: 1744026635000,
        hora_fin: '13:50',
        diff_days: 0,
        total: 5.461388888888889,
        total_time: '05:28',
        now: 1744123129000,
        fin_next: 0
      },
      {
        id: 2,
        id_local: 22,
        local: 'Yurest',
        id_usuario: 2,
        usuario: 'Alicia Pérez',
        avatar: '',
        observaciones: '',
        activo: 0,
        id_estado_firma: 0,
        estado_firma: 'No solicitada',
        firma: '',
        inicio: 1744029878000,
        hora_inicio: '14:44',
        fin: 1744042395000,
        hora_fin: '18:13',
        diff_days: 0,
        total: 3.4769444444444444,
        total_time: '03:29',
        now: 1744123872000,
        fin_next: 0
      }
    ]
  }


  /**
   * Obtener los fichajes de hoy
   *
   */
  override setData(data: ClockInDto) {
    const clockInToday = data.days.find((day) => day.date === format(new Date(), 'yyyy-MM-dd'));
    this.data = clockInToday ? clockInToday.rangos : [];
  }


  /**
   * Obtener datos
   *
   */
  getData(): Promise<ApiResponse> {
    const filters: ClockInFilters = new ClockInFilters();
    filters.id_local = this.widgetsManager.filters?.local.id || 0;

    return this.clockInService.getClockInList(filters);
  }

}
